import React, { useEffect, useState } from "react";
import "./footer.scss";
import { Container, Row, Col, Nav } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import { HashLink } from "react-router-hash-link";

export default function Footer() {
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    }, [pathname]);

    const [activeSection, setActiveSection] = useState("");

    useEffect(() => {
        const sections = document.querySelectorAll("section[id]");
        const options = { threshold: 0.6 };

        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    setActiveSection(entry.target.id);
                }
            });
        }, options);

        sections.forEach((section) => observer.observe(section));

        return () => observer.disconnect();
    }, []);

    return (
        <React.Fragment>
            <footer className="footer">
                <Container>
                    <div className="footer-top">
                        <Row className="gy-4">
                            <Col md={3} className="footer-col">
                                <div className="footer-title">
                                    <h2>Yacht Mumbai</h2>
                                    <h3>Experience luxury on the Arabian Sea with Mumbai's premier yacht and speed boat charter service.</h3>
                                </div>

                            </Col>
                            <Col md={3} className="footer-col">
                                <h5 className="text-uppercase">Quick Links</h5>
                                <ul>
                                    <li><Nav.Link as={Link} to="/">Home</Nav.Link></li>
                                    <li><Nav.Link as={Link} to="/full-fleet">Our Fleet</Nav.Link></li>
                                    <li><Nav.Link as={HashLink} to="/#experiences">Experiences</Nav.Link></li>
                                    <li><Nav.Link as={Link} to="/safety-guidelines">Safety</Nav.Link></li>
                                    <li><Nav.Link as={HashLink} to="/#contact">Contact</Nav.Link></li>
                                </ul>
                            </Col>
                            <Col md={3} className="footer-col">
                                <h5 className="text-uppercase">Services</h5>
                                <ul>
                                    <li><Nav.Link as={Link} to="/full-fleet?category=sail_yachts_tab">Luxury Yacht Charters</Nav.Link></li>
                                    <li><Nav.Link as={Link} to="/full-fleet?category=speed_boats_tab">Speed Boat Rentals</Nav.Link></li>
                                    <li><Nav.Link as={HashLink} to="/#experiences">Sunset Cruises</Nav.Link></li>
                                    <li><Nav.Link as={HashLink} to="/#experiences">Corporate Events</Nav.Link></li>
                                    <li><Nav.Link as={HashLink} to="/#experiences">Private Celebrations</Nav.Link></li>
                                    <li><Nav.Link as={HashLink} to="/#experiences">Wedding Proposals</Nav.Link></li>
                                </ul>
                            </Col>

                            <Col md={3} className="footer-col">
                                <h5 className="text-uppercase">Connect With Us</h5>
                                <ul>
                                    <li><Nav.Link as="a" href="tel:+919920088412">+91 99200 88412</Nav.Link></li>
                                </ul>
                            </Col>
                        </Row>
                    </div>

                    <div className="bottom-footer">
                        <p>© 2024 Yacht Mumbai. All rights reserved.</p>
                        <ul className="d-flex gap-3">
                            <li>
                                <Nav.Link as={HashLink} className={activeSection === "privacy-policy" ? "active" : ""} to="privacy-policy" eventKey="privacy-policy">
                                    Privacy Policy
                                </Nav.Link>
                            </li>
                            <li>
                                <Nav.Link as={HashLink} className={activeSection === "terms-of-use" ? "active" : ""} to="terms-of-use" eventKey="terms-of-use">
                                    Terms of Use
                                </Nav.Link>
                            </li>
                            <li>
                                <Nav.Link as={HashLink} className={activeSection === "safety-guidelines" ? "active" : ""} to="safety-guidelines" eventKey="safety-guidelines">
                                    Safety Guidelines
                                </Nav.Link>
                            </li>
                        </ul>
                    </div>
                </Container>
            </footer>
        </React.Fragment>
    )
}